import axios from "axios";
import {REQUEST_URL} from '../config/urls.js';

export const getPrecoFrete = async ()=>{
  let response = await axios.get(`${REQUEST_URL}/orcamentos/preco_frete`);
  return response.status === 200 ? response.data : [];
}
